export const mockData = {
  stats: {
    students: 'Hundreds of',
    experience: 30
  },
  features: [
    {
      title: 'All Skill Levels Welcome',
      description: 'Whether you\'re a complete beginner or looking to refine advanced techniques, our personalised approach ensures you progress at your own pace.'
    },
    {
      title: 'Comprehensive Learning Materials',
      description: 'Each lesson includes detailed lesson notes, theory docs, music charts (Tab and/or standard notation), plus video and audio files for practice at home.'
    },
    {
      title: 'Experienced & Certified Instructor',
      description: 'Learn from an instructor with 30+ years experience, Cert IV Training & Assessment, and proper clearances for safe, professional music education.'
    }
  ],
  pricing: [
    {
      name: 'Single Lesson',
      price: 50,
      period: '45 min',
      description: 'Professional one-on-one instruction',
      features: [
        '45-minute individual session',
        'Personalised instruction',
        'Guitar, Bass, or Ukulele',
        'Lesson notes included',
        'Downloadable theory docs',
        'Music charts (Tab/Standard notation)',
        'Video and audio practice files'
      ],
      popular: true
    }
  ],
  instructor: {
    name: 'Adrian Gravelle',
    title: 'Founder & Lead Instructor',
    bio: 'With over 30 years of teaching experience and a deep passion for music education, I\'ve helped hundreds of students develop their musical talents. Whether you\'re a complete beginner or looking to refine advanced techniques, my personalised approach ensures you progress at your own pace.',
    qualifications: [
      'Cert IV Training & Assessment',
      'Current Police Clearance Check',
      'Current Working With Children Check (WWCC)',
      '30+ Years Teaching Experience',
      'Secure and Safe Environment'
    ],
    specialties: [
      'Rock',
      'Blues',
      'Country',
      'Jazz',
      'Folk',
      'Pop'
    ]
  },
  faqs: [
    {
      question: 'Do I need to bring my own instrument?',
      answer: 'For your first lesson, we can provide an instrument if needed. However, for regular lessons, we recommend having your own instrument to practice at home. We can provide guidance on purchasing the right instrument for your needs and budget.'
    },
    {
      question: 'How long does it take to learn guitar/bass/ukulele?',
      answer: 'Every student progresses at their own pace. With consistent practice (15-30 minutes daily), most beginners can play simple songs within 2-3 months. However, music is a lifelong journey, and there\'s always something new to learn!'
    },
    {
      question: 'What age groups do you teach?',
      answer: 'We welcome students from 6 to 90 years old! Our teaching approach is tailored to each student\'s age, learning style, and goals.'
    },
    {
      question: 'Can I switch between instruments?',
      answer: 'Absolutely! Many students enjoy learning multiple instruments. We can create a curriculum that allows you to explore guitar, bass, and ukulele as you progress.'
    },
    {
      question: 'What is your cancellation policy?',
      answer: 'We require 24 hours\' notice for cancellations. Lessons cancelled with proper notice can be rescheduled at no charge. Lessons cancelled with less than 24 hours\' notice must still be paid; however, you may book a catch-up lesson at no additional cost within two weeks of the original time slot.'
    },
    {
      question: 'Do you offer online lessons?',
      answer: 'Currently, we focus on in-person lessons at our Maylands location. However, online lessons may be offered in the future. Please contact us if you\'re interested in online instruction.'
    }
  ],
  contact: {
    email: 'guitar101tuition@tuta.com',
    address: 'Steadfast Business Hub, 239 Magill Rd, Maylands SA 5069, Australia',
    hours: 'Mon-Wed: 3:00PM-9:00PM, Sat: 9:00AM-3:00PM'
  }
};